import React from 'react'
import PropTypes from 'prop-types'
import { Form, Popup } from 'semantic-ui-react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment'
import { css } from 'aphrodite'

import createStyles, { fontWeights } from './styles'

export class Datepicker extends React.PureComponent {
  render() {
    const {
      input = {},
      id,
      label,
      required,
      className,
      disabled,
      intl,
      popoverAttachment,
      popoverTargetAttachment,
      popoverTargetOffset,
      todayButton,
      meta: { touched, error, invalid },
      ...props
    } = this.props
    const styles = getStyles(props, this.context)

    return (
      <Form.Field
        color={`${touched && invalid ? 'danger' : ''}`}
        className={`${required ? 'required ' : ' '}${className}`}
      >
        {label && <label className={css(styles.label)}>{label}</label>}

        {touched && error ? (
          <Popup
            inverted
            trigger={
              <DatePicker
                className="form-control"
                {...input}
                fixedHeight
                todayButton={todayButton}
                label={label}
                id={id}
                dateForm="MM/DD/YYYY"
                selected={input.value ? moment(input.value) : null}
                disabled={disabled}
                popoverAttachment={popoverAttachment}
                popoverTargetAttachment={popoverTargetAttachment}
                popoverTargetOffset={popoverTargetOffset}
              />
            }
            content={error}
            on="focus"
          />
        ) : (
          <DatePicker
            className="form-control"
            {...input}
            fixedHeight
            todayButton={todayButton}
            label={label}
            id={id}
            dateForm="MM/DD/YYYY"
            selected={input.value ? moment(input.value) : null}
            disabled={disabled}
            popoverAttachment={popoverAttachment}
            popoverTargetAttachment={popoverTargetAttachment}
            popoverTargetOffset={popoverTargetOffset}
          />
        )}
      </Form.Field>
    )
  }
}

Datepicker.contextTypes = {
  theme: PropTypes.object,
}

const getStyles = createStyles((props, context, theme) => ({
  root: {
    marginBottom: 21,
  },

  label: {
    color: theme.colors.text,
    display: 'block',
    fontWeight: fontWeights.light,
    marginBottom: 7,
  },

  hint: {
    marginTop: 7,
  },
}))



// WEBPACK FOOTER //
// ./src/components/Datepicker.js